import { Observable } from 'rxjs';
import { ReferenceByEntity } from '@core/model/reference-by-entity';
import { mergeMap, take } from 'rxjs/operators';
import { inject } from '@angular/core';
import { API_BASE_DMEPOS_URL, TenantService } from '@core/service';
import { HttpClient } from '@angular/common/http';

export class QueueDMEPOSService {
  private apiBaseDmeposUrl = inject(API_BASE_DMEPOS_URL);
  private tenantService = inject(TenantService);
  private http = inject(HttpClient);

  getStatusReasons(): Observable<ReferenceByEntity> {
    return this.tenantService.getAll().pipe(
      take(1),
      mergeMap(tenants => {
        const anthemId = tenants.Anthem.tenantId;
        return this.http.get<ReferenceByEntity>(`${this.apiBaseDmeposUrl}tenants/${anthemId}/references/referencesByEntity`, {
          params: {
            entity: 'ProductLine',
            reference: 'Status',
            applicationKey: 'Pending',
            includeChild: 'true'
          }
        });
      })
    )
  }

}
